/* Skapad av Claude Code – varukorgen V3 (2026-09-23). EN motor för hela korgsidan.
   Principer:
   • Korgsidan är sju sektioner; FYRA uppdateras vid cart-ändringar (kärna, paket, favoriter,
     deals – markerade data-svd-cart-refresh). Alla fyra renderas om i SAMMA anrop via
     Section Rendering API (tak 5) = en renderingsvåg, inget "andra hopp".
   • Morfning i stället för innerHTML: befintliga noder patchas, rader nyckelmatchas på
     data-key → scrollankare, bilder och fokus överlever.
   • Direktrespons: knappar, antal, borttag och nya rader svarar på klicket (< 100 ms);
     PRISER räknas aldrig i klienten – visat pris === debiterat pris, summorna väntar på
     servern (pulserar mjukt medan den räknar).
   • Rabatt sätts ALDRIG här: raderna stämplas (_cart_deal, _spotlight_deal, _popup_deal,
     _paket_upgrade, _gwp …) och Deals Studio-motorerna prissätter i korg + kassa.
   • Gåvan vid gåvogränsen (_gwp + _gwp_gift): servern avgör, klienten utför (settleGift/syncGift)
     – i samma våg som klicket som tog korgen över eller under gränsen.
   • UI-läge (vald flik, öppna gåvor, öppen snabbvy/popup) ägs av klienten och
     återappliceras efter varje morfning i samma task (ingen blink). */
(function () {
  if (window.SvdCart) return;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var json = function (s, fb) { try { return s ? JSON.parse(s) : fb; } catch (e) { return fb; } };

  /* ---------- Mutationskö: alla cart-anrop i ordning (snabba klick träffar aldrig fel rad) ---------- */
  var chain = Promise.resolve();
  function enqueue(fn) { var run = function () { return fn(); }; chain = chain.then(run, run); return chain; }

  function root() { return $('.svd-cart--core') || $('[data-svd-cart-refresh]'); }
  function sectionIds() { return $$('[data-svd-cart-refresh]').map(function (el) { return el.dataset.sectionId; }).filter(Boolean).slice(0, 5); }
  /* Bara antalet ändras (rad finns kvar): kärnan + paketen räcker – favoriter och deals beror
     enbart på VILKA produkter som ligger i korgen (granskningen 23/9: ~0,3–0,6 s mindre serverarbete per +/−). */
  function qtyIds() { var ids = $$('[data-svd-cart-refresh][data-svd-cart-qty]').map(function (el) { return el.dataset.sectionId; }).filter(Boolean); return ids.length ? ids : sectionIds(); }
  function setBusy(on) { $$('[data-svd-cart-refresh]').forEach(function (r) { r.classList.toggle('is-updating', on); }); }
  function announce(msg) { var l = document.getElementById('SvdCartLive'); if (l) { l.textContent = ''; l.textContent = msg; } }
  function tr(name, fb) { var r = root(); return (r && r.dataset[name]) || fb; }
  function updatedMsg() { return tr('tUpdated', 'Varukorgen uppdaterad'); }
  function emit(name) { document.dispatchEvent(new CustomEvent(name)); }

  /* Sajtens korgbubbla (.thb-item-count) + temats egen drawer (tom korg: data-svd-count="0"). */
  function syncHeaderCount() {
    var el = $('[data-svd-count]');
    var n = el ? el.dataset.svdCount : null;
    if (n === null) return;
    $$('.thb-item-count').forEach(function (b) { b.textContent = n; });
    emit('cart:refresh');
  }

  /* Raderna identifieras med ett STABILT id (variant + plan + stämplar, data-svd-sid).
     Shopify byter radens nyckel (item.key) varje gång antalet ändras – nyckeln slås därför
     upp i DOM:en först när anropet faktiskt skickas (granskningen 23/9: tap 2–5 i en snabb
     serie gick annars till en död nyckel → 400 och tappades). */
  function rowBySid(sid) {
    if (!sid) return null;
    return $('.svd-cart__row[data-svd-sid="' + sid + '"]') || $('.svd-cart__row[data-key="' + sid + '"]');
  }
  function sidOf(row) { return row.dataset.svdSid || row.dataset.key; }

  /* ---------- Morfning ---------- */
  function morphAttrs(from, to) {
    var i, a;
    for (i = from.attributes.length - 1; i >= 0; i--) { a = from.attributes[i].name; if (!to.hasAttribute(a)) from.removeAttribute(a); }
    for (i = 0; i < to.attributes.length; i++) { a = to.attributes[i]; if (from.getAttribute(a.name) !== a.value) from.setAttribute(a.name, a.value); }
    if (from.tagName === 'INPUT' && from !== document.activeElement && from.value !== to.value) from.value = to.value;
  }
  /* Rader matchas på det stabila id:t (nyckeln byts vid antalsändring – då skulle raden annars
     ersättas av en ny nod och fokus/förankring tappas). */
  function morphKey(el) { return el.getAttribute ? (el.getAttribute('data-svd-sid') || el.getAttribute('data-key') || el.id || null) : null; }
  function morphEl(from, to) {
    /* Öppen snabbvy/popup rörs inte medan kunden använder den. */
    if (from.hasAttribute && from.hasAttribute('data-svd-open')) return;
    morphAttrs(from, to);
    if (from.tagName === 'SCRIPT' || from.tagName === 'STYLE') return;
    morphChildren(from, to);
  }
  function morphChildren(from, to) {
    var keyed = {}, c, k;
    for (c = from.firstElementChild; c; c = c.nextElementSibling) { k = morphKey(c); if (k) keyed[k] = c; }
    var fromChild = from.firstChild, toChild = to.firstChild;
    while (toChild) {
      var nextTo = toChild.nextSibling;
      if (toChild.nodeType === 1) {
        k = morphKey(toChild);
        var match = null;
        if (k && keyed[k]) { match = keyed[k]; delete keyed[k]; }
        else if (fromChild && fromChild.nodeType === 1 && fromChild.tagName === toChild.tagName && !morphKey(fromChild) && !k) match = fromChild;
        if (match) {
          if (match === fromChild) fromChild = fromChild.nextSibling; else from.insertBefore(match, fromChild);
          morphEl(match, toChild);
        } else from.insertBefore(toChild, fromChild);
      } else if (toChild.nodeType === 3 || toChild.nodeType === 8) {
        if (fromChild && fromChild.nodeType === toChild.nodeType) {
          if (fromChild.data !== toChild.data) fromChild.data = toChild.data;
          fromChild = fromChild.nextSibling;
        } else from.insertBefore(toChild, fromChild);
      }
      toChild = nextTo;
    }
    while (fromChild) { var nx = fromChild.nextSibling; from.removeChild(fromChild); fromChild = nx; }
  }
  /* Sidan får inte hoppa (Eriks krav). Ankare = det översta av korgens landmärken som syns
     helt i fönstret; växer eller krymper något OVANFÖR det kompenseras scrollen i samma
     task (före målning). Webbläsarens egen förankring räcker inte: den tappar ankaret när
     sektionerna ovanför byggs om och stängs av när body-paddingen (kassabaren) ändras
     (granskningen 23/9: Chrome 54–168 px, WebKit 83–102 px). Den inbyggda förankringen
     justerar synkront vid layout – mätningen efter fn() ser därför bara RESTEN, så de två
     kan aldrig dubbelkompensera. Aldrig smooth: temat sätter scroll-behavior globalt. */
  var ANCHORS = '.svd-cart__h1, .svd-cart__meterwrap, .svd-cart__row, .svd-cart__gifts, .svd-cart__unlock, .svd-cart__pk-part, .svd-cart__fav-part > .svd-cart__h2, .svd-cart__chips, .svd-cart__grid, .svd-cart__deals-part > .svd-cart__h2, .svd-cart__deal, .svd-cart__why, .svd-cart__rev-sec';
  function pickAnchor() {
    var vh = window.innerHeight || document.documentElement.clientHeight, pick = null;
    $$(ANCHORS).some(function (el) {
      /* Sidokolumnen på dator är sticky – den står still oavsett vad som ändras ovanför. */
      if (el.closest('.is-removing, .is-pending, [hidden], .svd-cart__side')) return false;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top >= 0 && r.top < vh) { pick = el; return true; }
      return false;
    });
    return pick;
  }
  function keepAnchor(fn) {
    var a = pickAnchor(), before = a ? a.getBoundingClientRect().top : 0;
    fn();
    if (!a || !a.isConnected) return;
    var d = Math.round(a.getBoundingClientRect().top - before);
    if (d === 0) return;
    var html = document.documentElement, sb = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollBy(0, d);
    html.style.scrollBehavior = sb;
  }
  var lastHtml = {};
  function swapOne(id, html) {
    if (!html || html === lastHtml[id]) return;
    lastHtml[id] = html;
    var wrapper = document.getElementById('shopify-section-' + id);
    if (!wrapper) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
    if (!next) return;
    var fallback = next.innerHTML;
    try { morphChildren(wrapper, next); }
    catch (err) { console.error('[SvdCart] morfning föll tillbaka', err); wrapper.innerHTML = fallback; }
  }
  /* Alla sektioner byts i EN förankrad operation, sedan återappliceras UI-läget. */
  function swapAll(sections) {
    if (!sections) return;
    keepAnchor(function () {
      Object.keys(sections).forEach(function (id) { swapOne(id, sections[id]); });
      applyUi();
    });
  }
  /* Sektionerna renderas i SAMMA malls sammanhang som sidan – även en alternativ mall
     (/cart?view=v3, provläget på live före bytet). Övriga parametrar följer inte med. */
  function here() {
    var v = null; try { v = new URLSearchParams(window.location.search).get('view'); } catch (e) {}
    return window.location.pathname + (v ? '?view=' + encodeURIComponent(v) : '');
  }
  function refresh() {
    var u = here();
    return fetch(u + (u.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(sectionIds().join(',')))
      .then(function (r) { return r.json(); })
      .then(function (d) { swapAll(d); emit('svd-cart:updated'); syncHeaderCount(); })
      .catch(function (e) { console.error('[SvdCart] refresh', e); });
  }
  function post(url, body, ids) {
    body.sections = ids || sectionIds();
    body.sections_url = here();
    setBusy(true);
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        if (r.ok) return r.json();
        /* Shopifys eget (översatta) felmeddelande följer med, t.ex. lagertaket vid 422
           ("… lades endast 4 artiklar till") – antalet har då ändå satts till max. */
        return r.json().catch(function () { return {}; }).then(function (j) { var e = new Error(url + ' ' + r.status); e.desc = j && (j.description || j.message); throw e; });
      })
      .then(function (d) {
        /* Gåvan vid gåvogränsen avgörs FÖRE bytet: passerar korgen gränsen läggs gåvan till (eller
           tas bort) i ett uppföljningsanrop och först det svaret ritas – kunden ser EN våg, aldrig
           en 39 kr-rad på väg bort eller en gåvorad som dyker upp i efterhand. */
        if (d.sections) return settleGift(d, 0).then(function (d2) { swapAll(d2.sections); emit('svd-cart:updated'); syncHeaderCount(); return d2; });
        return refresh().then(function () { return d; });
      })
      .finally(function () { setBusy(false); });
  }
  /* ---------- Gåvan vid gåvogränsen (steg 0b, 2026-09-23) ----------
     Servern (svd-cart-core-v3) avgör allt och skriver beslutet på kärnans rot:
       data-svd-gift-add="<variant>"       → gåvan saknas och korgen (utan gåvans eget pris) ≥ gränsen
       data-svd-gift-set="<key>:0,…"       → _gwp_gift-rader som ska bort (under gränsen, dubbletter,
                                              eller rader som regeln inte gjort gratis)
     Regeln i Deals Studio gör raden gratis; temat lägger till/tar bort. Priser räknas aldrig här.
     giftTried: ett misslyckat tillägg görs inte om under sidvisningen (annars kunde en pausad regel
     ge lägg till → ta bort i evighet); ett LYCKAT tillägg (data-svd-gift-ok) nollställer spärren så
     att kunden kan gå under och över gränsen hur många gånger som helst. Borttag spärras först efter
     två MISSLYCKADE försök per rad – radnyckeln är deterministisk (samma gåva får samma nyckel varje
     gång), så lyckade borttag får aldrig räknas (granskningen 23/9: + + − − lämnade gåvan kvar). */
  var GIFT_PROPS = { _gwp: 'true', _gwp_gift: 'grans' };
  var giftTried = {}, giftBusy = false;
  function giftPlan(el) {
    if (!el) return null;
    if (el.getAttribute('data-svd-gift-ok') === '1') delete giftTried['a' + el.getAttribute('data-svd-gift-vid')];
    var set = {}, keys = [];
    (el.getAttribute('data-svd-gift-set') || '').split(',').forEach(function (p) {
      var i = p.lastIndexOf(':'); if (i < 1) return;
      var k = p.slice(0, i); if ((giftTried['s' + k] || 0) >= 2) return;
      set[k] = Number(p.slice(i + 1)) || 0; keys.push(k);
    });
    if (keys.length) return { url: '/cart/update.js', body: { updates: set }, keys: keys, mark: [], fail: keys.map(function (k) { return 's' + k; }) };
    var add = el.getAttribute('data-svd-gift-add') || '';
    if (add && !giftTried['a' + add]) return { url: '/cart/add.js', body: { items: [{ id: Number(add), quantity: 1, properties: GIFT_PROPS }] }, keys: [], mark: ['a' + add], fail: [] };
    return null;
  }
  function giftMark(list) { list.forEach(function (m) { giftTried[m] = (giftTried[m] || 0) + 1; }); }
  function giftRootIn(sections) {
    var r = root(), id = r && r.dataset.sectionId, html = sections && id && sections[id]; if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-svd-cart-refresh]');
  }
  function settleGift(d, hops) {
    var plan = hops < 2 ? giftPlan(giftRootIn(d.sections)) : null; if (!plan) return Promise.resolve(d);
    giftMark(plan.mark);
    plan.body.sections = sectionIds(); plan.body.sections_url = here();
    return fetch(plan.url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(plan.body) })
      .then(function (r) { if (!r.ok) throw new Error(plan.url + ' ' + r.status); return r.json(); })
      .then(function (d2) { return d2.sections ? settleGift(d2, hops + 1) : d; })
      .catch(function (e) { console.error('[SvdCart] gåvan vid gränsen', e); giftMark(plan.fail); return d; });
  }
  /* Sidladdning, bakåtknapp och omhämtningar: beslutet står redan i DOM:en – utför det i kön. */
  function syncGift() {
    if (giftBusy) return;
    var plan = giftPlan(root()); if (!plan) return;
    giftBusy = true;
    giftMark(plan.mark);
    plan.keys.forEach(function (k) { var r = $('.svd-cart__row[data-key="' + k + '"]'); if (r) r.classList.add('is-removing'); fadeGift(k, true); });
    mutate(plan.url, function () { return plan.body; }, sectionIds())
      .catch(function (e) { console.error('[SvdCart] gåvan vid gränsen', e); giftMark(plan.fail); plan.keys.forEach(function (k) { var r = $('.svd-cart__row[data-key="' + k + '"]'); if (r) r.classList.remove('is-removing'); fadeGift(k, false); }); dropPending(); })
      .then(function () { giftBusy = false; });
  }
  /* Kroppen byggs FÖRST när anropet står på tur i kön (färska radnycklar). null = inget att göra. */
  function mutate(url, build, ids) {
    return enqueue(function () {
      var body = build(); if (!body) return null;
      return post(url, body, ids).then(function (d) { announce(updatedMsg()); return d; });
    });
  }
  function update(updates) { return mutate('/cart/update.js', function () { return { updates: updates }; }); }
  /* Stämplarna kommer ENBART från knappens data-props – ingen standardflagga. */
  function add(items) {
    return enqueue(function () {
      return post('/cart/add.js', { items: items.map(function (it) { return { id: Number(it.id), quantity: it.quantity || 1, properties: it.properties || {} }; }) })
        .then(function (d) { announce(updatedMsg()); return d; });
    });
  }

  /* ---------- Antal: första tappet skickas direkt, tap under flygningen samlas till ETT uppföljningsanrop ----------
     qtyWant = kundens senaste önskade antal per rad (stabilt id). Värdet ligger kvar tills servern
     bekräftat just det antalet, så en morfning med ett äldre svar aldrig hoppar tillbaka i rutan. */
  var qtyWant = {}, qtyFlying = {}, removing = {};
  function pumpQty(sid) {
    if (qtyFlying[sid] || !(sid in qtyWant)) return;
    var v = qtyWant[sid]; qtyFlying[sid] = true;
    mutate('/cart/change.js', function () {
      var r = rowBySid(sid); if (!r || !r.dataset.key || removing[sid]) return null;
      return { id: String(r.dataset.key), quantity: Number(v) };
    }, qtyIds())
      .catch(function (e) { if (qtyWant[sid] === v) delete qtyWant[sid]; announce((e && e.desc) || tr('tError', 'Något gick fel – försök igen')); refresh(); })
      .finally(function () { delete qtyFlying[sid]; if (qtyWant[sid] === v) delete qtyWant[sid]; pumpQty(sid); });
  }
  function setQty(row, val) {
    var input = $('[data-svd-qty-input]', row);
    if (input) input.value = val;
    if (val === 0) { removeRow(row); return; }
    var sid = sidOf(row);
    qtyWant[sid] = val;
    pumpQty(sid);
  }

  /* ---------- Borttag: raden tonas ut (220 ms) direkt; gåvor som blir föräldralösa följer med i SAMMA anrop ---------- */
  function orphanGifts(row) {
    var pid = row.dataset.svdPid; if (!pid) return [];
    var remain = 0;
    $$('[data-svd-pid]').forEach(function (r) { if (r !== row && !r.hasAttribute('data-svd-gwp') && !r.classList.contains('is-removing') && r.dataset.svdPid === pid) remain += parseInt(r.dataset.svdPqty, 10) || 0; });
    return $$('[data-svd-gwpmain="' + pid + '"]').filter(function (g) { return remain < (parseInt(g.dataset.svdGwpmin, 10) || 1) && g.dataset.key; });
  }
  function fadeGift(key, on) { $$('[data-svd-gkey="' + key + '"]').forEach(function (g) { g.classList.toggle('is-removing', on); }); }
  function removeRow(row) {
    if (!row.dataset.key) { keepAnchor(function () { row.remove(); }); return; }
    var sid = sidOf(row);
    if (removing[sid]) return;
    removing[sid] = true;
    row.classList.add('is-removing');
    var gkeys = orphanGifts(row).map(function (g) { return g.dataset.key; });
    gkeys.forEach(function (k) { fadeGift(k, true); });
    delete qtyWant[sid];
    /* Nyckeln slås upp när anropet går (ett pågående antalsanrop kan ha bytt den). */
    mutate(gkeys.length ? '/cart/update.js' : '/cart/change.js', function () {
      var r = rowBySid(sid); if (!r || !r.dataset.key) return null;
      if (!gkeys.length) return { id: String(r.dataset.key), quantity: 0 };
      var up = {}; up[r.dataset.key] = 0; gkeys.forEach(function (k) { up[k] = 0; });
      return { updates: up };
    }).catch(function () {
      var r = rowBySid(sid) || row;
      r.classList.remove('is-removing');
      gkeys.forEach(function (k) { fadeGift(k, false); });
      announce(tr('tError', 'Något gick fel – försök igen'));
    }).finally(function () { delete removing[sid]; });
  }

  /* ---------- Lägg till: knappen kvitterar direkt, raden syns direkt (väntande) tills servern svarat ---------- */
  /* Den väntande raden läggs ÖVERST – Shopify listar nyast först, så den riktiga raden hamnar
     på samma plats när svaret kommer. Slås tillägget ihop med en befintlig rad (samma variant,
     inga stämplar) visas ingen väntande rad – den skulle bara försvinna igen. */
  function pendingRow(data, vid, props) {
    var list = $('.svd-cart__list'); if (!list || !data) return null;
    var plain = !props || !Object.keys(props).length;
    if (plain && vid && $$('.svd-cart__row[data-svd-vid="' + vid + '"]').some(function (r) { return r.hasAttribute('data-svd-plain'); })) return null;
    var li = document.createElement('li');
    li.className = 'svd-cart__row is-pending';
    li.innerHTML = '<span class="svd-cart__rimg">' + (data.i ? '<img alt="" width="62" height="62">' : '') + '</span>' +
      '<div class="svd-cart__rinfo"><div class="svd-cart__rtext"><span class="svd-cart__rname"></span></div>' +
      '<div class="svd-cart__rfoot"><div class="svd-cart__rprice"><b></b></div></div></div>';
    if (data.i) $('img', li).src = data.i;
    $('.svd-cart__rname', li).textContent = (data.t || '').split(' – ')[0].split(' - ')[0];
    $('.svd-cart__rprice b', li).textContent = data.p || '';
    keepAnchor(function () { list.insertBefore(li, list.firstElementChild); });
    return li;
  }
  /* hold = knappen förblir låst efter 1,6 s (paketbytet låser upp den själv när det är klart). */
  function flash(btn, ok, hold) {
    var label = btn.dataset.label || btn.textContent;
    btn.dataset.label = label;
    btn.classList.toggle('is-added', ok);
    btn.textContent = ok ? tr('tAdded', 'Tillagd ✓') : tr('tRetry', 'Försök igen');
    setTimeout(function () { if (btn.isConnected) { btn.classList.remove('is-added'); btn.textContent = label; if (!hold) btn.disabled = false; } }, 1600);
  }
  function unflash(btn) { if (!btn) return; btn.classList.remove('is-added'); if (btn.dataset.label) btn.textContent = btn.dataset.label; btn.disabled = false; }
  function addFromButton(btn, data) {
    var props = json(btn.dataset.props, {});
    btn.disabled = true;
    flash(btn, true);
    var host = btn.closest('[data-svd-qv]');
    var pend = pendingRow(data || (host && json(host.dataset.svdQv, null)), btn.dataset.variantId, props);
    /* Deal-kortets statistik räknas även när tillägget sker från snabbvyn (stämpeln bär handeln). */
    var spot = btn.closest('[data-svd-spotlight]') || (props._spotlight_deal && $('[data-svd-spotlight][data-handle="' + props._spotlight_deal + '"]'));
    /* Blockstatistik: `data` finns BARA när tillägget kommer från snabbvyn (korten är själva qv-värdar,
       så host säger inget) – då tillskrivs blocket snabbvyn öppnades från. */
    var fromQv = !!data, card = btn.closest('[data-handle]');
    var srcBlock = spot ? 'deals' : props._unlock ? 'unlock' : (fromQv ? (qvSource || 'okand') : blockOf(btn));
    /* _svd_via = blocket raden lades från (24/9). Följer med orderraden → kassapixeln skickar
       checkout_blocks, så "köpte via blocket" bara räknas när produkten faktiskt ligger kvar i ordern. */
    if (srcBlock !== 'okand') props._svd_via = srcBlock;
    if (spot) { track('svd_spotlight_add', spot); blk('deals', 'add', { handle: spot.dataset.handle, position: Number(spot.dataset.position) || 0, via: fromQv ? 'snabbvy' : 'kort' }); }
    else if (!props._unlock) blk(srcBlock, 'add', { handle: (card && card.dataset.handle) || (host && host.dataset.handle) || null, title: data && data.t, via: fromQv ? 'snabbvy' : 'kort' });
    /* Frys blockets data VID klicket: morfningen patchar noden på plats, så efter svaret visar
       den redan NÄSTA gräns (fs → gift). Verifierat live 24/9. */
    var unlockEl = props._unlock ? btn.closest('[data-svd-unlock]') : null, unlockSnap = unlockEl ? unlockSnapshot(unlockEl) : null, before = unlockEl ? meterTotal() : 0;
    return add([{ id: btn.dataset.variantId, properties: props }])
      .then(function (d) { if (unlockSnap) trackUnlockAdd(unlockSnap, before, meterTotal()); return d; })
      .catch(function () { if (pend) keepAnchor(function () { pend.remove(); }); flash(btn, false); });
  }

  /* ---------- Paketbyte (flyttat från svd-cart-upgrade.js, auditens våg 1–2) ----------
     Läser korgen ur DOM:en (sedan 23/9 kväll, se domCart), minskar 1 st av varje paketprodukts första
     RENA rad i ETT /cart/update.js-anrop (atomiskt), lägger paket-produkten som EN rad och stämplar
     orderattributet _paket_upgrade. GWP-vakten avbryter om en gåvotröskel skulle brytas;
     misslyckas tillägget återställs raderna. */
  var DEAL_PROPS = ['_gift', '_cart_deal', '_popup_deal', '_spotlight_deal', '_godispaket', '_leksakspaket', '_slowfeeder_tillbehor', '_prenpaket', '_paket_upgrade', '_prengava', '_gwp'];
  function isClean(it) {
    if (it.selling_plan_allocation) return false;
    var p = it.properties || {};
    for (var i = 0; i < DEAL_PROPS.length; i++) if (p[DEAL_PROPS[i]]) return false;
    return (it.original_line_price || 0) <= (it.final_line_price || 0);
  }
  function cartJs() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('/cart.js'); return r.json(); }); }
  function rawPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  /* Korgens läge ur DOM:en (Eriks önskemål 23/9 kväll: paketet ska kvitteras direkt och läggas till
     snabbare). Raderna bär variant, produkt, handle, antal, nyckel, "ren rad" (data-svd-plain) och
     radrabatt (data-svd-disc); gåvorna i sidokolumnen bär _gwp_main/_gwp_min; roten bär orderattributet
     _paket_upgrade. Det är exakt vad paketbytet behöver – /cart.js-läsningen (ett anrop, ~0,3–0,5 s) är
     borta. Kön garanterar att DOM:en speglar senaste serversvar när anropet står på tur; väntande och
     borttagna rader räknas inte. Ren rad = utan plan, utan stämplar, utan radrabatt (samma som isClean). */
  function domCart() {
    var items = $$('.svd-cart__row[data-key]').filter(function (r) { return !r.classList.contains('is-removing') && !r.classList.contains('is-pending'); })
      .map(function (r) { return { key: r.dataset.key, variant_id: Number(r.dataset.svdVid) || 0, product_id: String(r.dataset.svdPid || ''), handle: r.dataset.svdHandle || '', quantity: parseInt(r.dataset.svdPqty, 10) || 0, gwp: r.hasAttribute('data-svd-gwp'), clean: r.hasAttribute('data-svd-plain') && !r.hasAttribute('data-svd-disc') && !r.hasAttribute('data-svd-gwp'), row: r }; });
    var gifts = $$('.svd-cart__side [data-svd-gkey][data-svd-vid]').map(function (g) { return { main: String(g.dataset.svdGwpmain || ''), min: parseInt(g.dataset.svdGwpmin, 10) || 1 }; });
    var r = root();
    return { items: items, gifts: gifts, attr: String((r && r.dataset.svdPaketAttr) || '') };
  }
  function upgrade(payload, btn, data) {
    var slide = btn && btn.closest('.svd-cart__pk-slide');
    blk('paket', 'upgrade', { rule: payload.rule, title: (data && data.t) || (slide && slide.dataset.title) || null, via: data ? 'snabbvy' : 'kort' });
    var paket = (payload.paket || []).map(function (p) { return { h: p.h, v: Number(p.v) || 0 }; });
    var props = payload.stamp ? { _paket_upgrade: String(payload.rule) } : {};
    props._svd_via = 'paket';
    var host = btn && btn.closest('[data-svd-qv]');
    var qv = data || (host ? json(host.dataset.svdQv, null) : null);
    /* Direkt kvittens, som favoriterna: knappen blir "Tillagd ✓" (låst tills bytet är klart), paketet syns
       överst som väntande rad och raderna som byts ut tonas ut – allt före första anropet. */
    if (btn) { btn.disabled = true; flash(btn, true, true); }
    var pend = pendingRow(qv, String(payload.add), props);
    var cart = domCart(), ops = [];
    paket.forEach(function (e) {
      var m = null;
      cart.items.some(function (it) { if (!it.clean) return false; if (e.v > 0 ? it.variant_id === e.v : it.handle === e.h) { m = it; return true; } return false; });
      if (m) ops.push({ key: m.key, qty: m.quantity - 1, vid: m.variant_id, pid: m.product_id, row: m.row });
    });
    /* GWP-vakten: skulle borttaget bryta en gåvotröskel görs ingenting. */
    var counts = {}, opPid = {};
    cart.items.forEach(function (it) { if (!it.gwp) counts[it.product_id] = (counts[it.product_id] || 0) + it.quantity; });
    ops.forEach(function (o) { opPid[o.pid] = true; });
    var blocked = cart.gifts.some(function (g) { return g.main && opPid[g.main] && (counts[g.main] || 0) - 1 < g.min; });
    var undo = function () { ops.forEach(function (o) { o.row.classList.remove('is-removing'); }); if (pend) keepAnchor(function () { pend.remove(); }); };
    if (blocked) { undo(); unflash(btn); return Promise.resolve(); }
    ops.forEach(function (o) { if (o.qty === 0) o.row.classList.add('is-removing'); });
    var attrBefore = cart.attr, list = attrBefore.split(/[\s,]+/).filter(Boolean);
    /* Storleksbyte (kind "storlek", SMILE 2026-10-28) är ingen paketprodukt → orderattributet
       _paket_upgrade (paketstatistiken) rörs inte. */
    var isSize = payload.kind === 'storlek';
    if (!isSize && list.indexOf(String(payload.add)) === -1) list.push(String(payload.add));
    var attrs = isSize ? {} : { _paket_upgrade: list.join(',') };
    var item = { id: payload.add, quantity: 1, properties: props };
    var done = [];
    return enqueue(function () {
      setBusy(true);
      var r;
      if (ops.length) {
        /* Två anrop: minska raderna + stämpla orderattributet i SAMMA update.js (utan sektioner), sedan
           paketet MED sektioner (= renderingen kommer i det svaret). */
        var up = {}; ops.forEach(function (o) { up[o.key] = o.qty; });
        r = rawPost('/cart/update.js', { updates: up, attributes: attrs }).then(function () { done = ops; return post('/cart/add.js', { items: [item] }); });
      } else {
        /* Inget att minska ("Lägg till"): paketet först (renderingen ett anrop tidigare), attributet
           efteråt – det påverkar ingen rendering. */
        r = post('/cart/add.js', { items: [item] }).then(function () { return isSize ? null : rawPost('/cart/update.js', { attributes: attrs }); });
      }
      return r.catch(function (err) {
        console.error('[SvdCart] paketbytet misslyckades', err);
        undo();
        if (btn && btn.isConnected) flash(btn, false);
        var up2 = {}, readd = [];
        done.forEach(function (o) { if (o.qty > 0) up2[o.key] = o.qty + 1; else readd.push({ id: o.vid, quantity: 1, properties: {} }); });
        var q = Promise.resolve();
        /* Orderattributet återställs också – annars attribueras ett paket som aldrig kom i korgen. */
        if (done.length) q = q.then(function () { return rawPost('/cart/update.js', isSize ? { updates: up2 } : { updates: up2, attributes: { _paket_upgrade: attrBefore } }); });
        if (readd.length) q = q.then(function () { return rawPost('/cart/add.js', { items: readd }); });
        return q.catch(function (e) { console.error('[SvdCart] återställningen', e); }).then(refresh);
      }).finally(function () { setBusy(false); });
    }).finally(function () { if (btn && btn.isConnected) btn.disabled = false; });
  }

  /* ---------- Snabbvyn: fylls ur triggerns förrenderade JSON – öppnas utan nätverk ---------- */
  var decoder = document.createElement('textarea');
  function rich(t) {
    decoder.innerHTML = String(t || ''); var plain = decoder.value;
    var esc = plain.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return esc.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>').replace(/\*\*/g, '');
  }
  var qvData = null;
  var qvSource = null;
  function openQv(host) {
    var d = json(host && host.dataset.svdQv, null), sheet = $('[data-svd-qv-sheet]');
    if (!d || !sheet) return;
    qvData = d;
    qvSource = blockOf(host);
    blk('snabbvy', 'open', { source: qvSource, title: d.t || null });
    var img = $('[data-qv-img]', sheet);
    var cardImg = $('img', host);
    img.src = cardImg ? cardImg.currentSrc || cardImg.src : (d.i || '');
    img.alt = d.t || '';
    if (d.i && img.src !== d.i) { var hi = new Image(); hi.onload = function () { if (qvData === d) img.src = d.i; }; hi.src = d.i; }
    $('[data-qv-t]', sheet).textContent = d.t || '';
    var sub = $('[data-qv-s]', sheet); sub.textContent = d.s || ''; sub.hidden = !d.s;
    $('[data-qv-p]', sheet).textContent = d.p || '';
    $('[data-qv-o]', sheet).textContent = d.o || '';
    $('.svd-qv__price', sheet).classList.toggle('is-deal', !!d.o);
    var btnEl = $('[data-svd-qv-add]', sheet);
    var sv = $('[data-qv-sv]', sheet); sv.hidden = !d.sv; sv.textContent = d.sv ? (btnEl.dataset.saveLabel || 'Spara') + ' ' + d.sv : '';
    /* Stycken och punkter (Erik 23/9: strukturerat, aldrig avkapat). Texten är escapad –
       bara **fetstil** blir <b>. */
    var body = $('[data-qv-body]', sheet); body.innerHTML = '';
    var ul = null;
    (d.b || []).forEach(function (blk) {
      var html = rich(blk[1]);
      if (blk[0] === 'li') {
        if (!ul) { ul = document.createElement('ul'); ul.className = 'svd-qv__list'; body.appendChild(ul); }
        var li = document.createElement('li'); li.innerHTML = html; ul.appendChild(li);
      } else {
        ul = null;
        var pEl = document.createElement('p'); pEl.className = blk[0] === 'lead' ? 'svd-qv__lead' : ''; pEl.innerHTML = html; body.appendChild(pEl);
      }
    });
    var x = $('[data-qv-x]', sheet), xl = $('ul', x); xl.innerHTML = '';
    if (d.xi && d.xi.length) {
      d.xi.forEach(function (it) { var li = document.createElement('li'); li.innerHTML = (it[0] ? '<img alt="" width="40" height="40">' : '') + '<span></span>'; if (it[0]) $('img', li).src = it[0]; $('span', li).textContent = it[1]; xl.appendChild(li); });
      x.hidden = false; x.classList.add('has-imgs');
    } else if (d.x) {
      var li2 = document.createElement('li'); li2.textContent = d.x; xl.appendChild(li2); x.hidden = false; x.classList.remove('has-imgs');
    } else x.hidden = true;
    $('.svd-qv__scroll', sheet).scrollTop = 0;
    var btn = $('[data-svd-qv-add]', sheet);
    btn.textContent = d.c || btn.dataset.label;
    btn.disabled = !d.a;
    btn.classList.remove('is-added');
    sheet.hidden = false;
    sheet.setAttribute('data-svd-open', '');
    document.documentElement.style.overflow = 'hidden';
    /* Fokus till arket (inte X-knappen) – ingen fokusring vid tryck, men skärmläsare hamnar rätt. */
    var dlg = $('.svd-qv__sheet', sheet); if (dlg) { dlg.setAttribute('tabindex', '-1'); dlg.focus({ preventScroll: true }); }
  }
  function closeQv() {
    var sheet = $('[data-svd-qv-sheet]'); if (!sheet || sheet.hidden) return;
    sheet.hidden = true; sheet.removeAttribute('data-svd-open'); qvData = null;
    if (!$('[data-svd-pop][data-svd-open]')) document.documentElement.style.overflow = '';
  }

  /* ---------- Flikar, gåvogrupp, paketrubrik: klientens UI-läge ---------- */
  var ui = { tab: null, giftsOpen: false, pk: 0 };
  function applyUi() {
    /* Pågående antal och borttag ligger kvar visuellt tills servern bekräftat dem. */
    Object.keys(qtyWant).forEach(function (sid) { var r = rowBySid(sid), i = r && $('[data-svd-qty-input]', r); if (i && i !== document.activeElement) i.value = qtyWant[sid]; });
    Object.keys(removing).forEach(function (sid) { var r = rowBySid(sid); if (r) r.classList.add('is-removing'); });
    var chips = $$('[data-svd-tab]');
    if (chips.length) {
      var ids = chips.map(function (c) { return c.dataset.svdTab; });
      if (ui.tab === null || ids.indexOf(ui.tab) === -1) ui.tab = ids[0];
      chips.forEach(function (c) { var on = c.dataset.svdTab === ui.tab; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); });
      $$('[data-svd-panel]').forEach(function (p) { p.hidden = p.dataset.svdPanel !== ui.tab; });
    }
    $$('[data-svd-giftgrp]').forEach(function (g) {
      g.classList.toggle('is-open', ui.giftsOpen);
      var h = $('[data-svd-giftgrp-toggle]', g); if (h) h.setAttribute('aria-expanded', ui.giftsOpen ? 'true' : 'false');
      var l = $('[data-svd-giftgrp-list]', g); if (l) l.hidden = !ui.giftsOpen;
    });
    /* Produkten som visas i "Deals endast i varukorgen" har bättre pris där – dölj den i favoriterna. */
    var dealH = {};
    $$('[data-svd-spotlight]').forEach(function (d) { dealH[d.dataset.handle] = 1; });
    $$('.svd-cart__card[data-handle]').forEach(function (c) { c.hidden = !!dealH[c.dataset.handle]; });
    initRails();
    initCountdown();
    padSticky();
    trackViews();
  }
  function selectTab(chip) {
    ui.tab = chip.dataset.svdTab;
    applyUi();
    var bar = chip.parentNode;
    var left = chip.offsetLeft - (bar.clientWidth - chip.offsetWidth) / 2;
    bar.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  /* Tunn scrollindikator under favoritraden + paketkarusellens rubrik/prickar. */
  function initRails() {
    $$('[data-svd-grid]').forEach(function (g) {
      if (g.__svd) return; g.__svd = true;
      var thumb = $('[data-svd-thumb]', g.parentNode);
      var upd = function () {
        if (!thumb) return;
        var ratio = Math.min(1, g.clientWidth / (g.scrollWidth || 1)), max = g.scrollWidth - g.clientWidth;
        thumb.style.width = (ratio * 100) + '%';
        thumb.style.transform = 'translateX(' + (max > 0 ? (g.scrollLeft / max) * (100 / ratio - 100) : 0) + '%)';
      };
      g.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
    $$('[data-svd-pk]').forEach(function (rail) {
      var slides = $$('.svd-cart__pk-slide', rail);
      if (!rail.__svd) {
        rail.__svd = true;
        var raf = 0;
        rail.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var s = $$('.svd-cart__pk-slide', rail); if (!s.length) return;
            var w = s[0].getBoundingClientRect().width + 10, max = rail.scrollWidth - rail.clientWidth;
            var i = max > 0 && rail.scrollLeft >= max - 4 ? s.length - 1 : Math.max(0, Math.min(s.length - 1, Math.round(rail.scrollLeft / w)));
            if (i === ui.pk) return;
            ui.pk = i; paintPk(rail, true);
          });
        }, { passive: true });
      }
      if (ui.pk >= slides.length) ui.pk = 0;
      paintPk(rail, false);
    });
  }
  function paintPk(rail, animate) {
    var s = $$('.svd-cart__pk-slide', rail), h = $('[data-svd-pk-h]'), dots = $$('[data-svd-pk-dots] i');
    var title = s[ui.pk] && s[ui.pk].dataset.title;
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === ui.pk); });
    if (!h || !title || h.textContent === title) return;
    if (!animate) { h.textContent = title; return; }
    h.classList.add('is-swap');
    setTimeout(function () { h.textContent = title; h.classList.remove('is-swap'); }, 220);
  }

  /* ---------- Reserverad-nedräkning: sluttid i sessionStorage, EN timer ---------- */
  var reserveTimer = null;
  function initCountdown() {
    var el = $('[data-svd-countdown]'); if (!el || reserveTimer) return;
    var key = 'svd_cart_reserve_until', until = parseInt(sessionStorage.getItem(key), 10);
    if (!until || until < Date.now()) { until = Date.now() + (parseInt(el.dataset.minutes, 10) || 10) * 60000; sessionStorage.setItem(key, until); }
    var tick = function () {
      var live = $('[data-svd-countdown]'); if (!live) { clearInterval(reserveTimer); reserveTimer = null; return; }
      var left = Math.max(0, Math.floor(((parseInt(sessionStorage.getItem(key), 10) || until) - Date.now()) / 1000));
      live.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    };
    reserveTimer = setInterval(tick, 1000); tick();
  }

  /* Mobil: kassabaren ligger fast i botten – ge sidan motsvarande luft. */
  function padSticky() {
    var bar = $('[data-svd-sticky]');
    var on = bar && getComputedStyle(bar).position === 'fixed' && getComputedStyle(bar).display !== 'none';
    document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
  }
  window.addEventListener('resize', function () { requestAnimationFrame(padSticky); }, { passive: true });

  /* ---------- Spotlight-statistik (dealsens kort): svd_spotlight_view/add ---------- */
  var seen = {};
  function publish(name, payload) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload)); } catch (e) {}
  }
  function track(name, el) { publish(name, { handle: el.dataset.handle, position: Number(el.dataset.position) || 0 }); }
  function trackViews() { $$('[data-svd-spotlight]').forEach(function (el) { if (!seen[el.dataset.handle]) { seen[el.dataset.handle] = 1; track('svd_spotlight_view', el); } }); trackUnlockViews('cart'); trackBlockViews(); }

  /* ---------- Blockstatistik (24/9): svd_cart_block i PostHog, block=unlock, action=view|add ----------
     Visningar dedupas per sidladdning på via+gräns+produkt, så omrenderingar vid varje korgändring
     inte blåser upp talet – men byter gränsen (fs → gift efter ett tillägg) räknas den nya vyn.
     Vid add: total före/efter (öre → kr) och om gränsen nåddes. Fel i mätningen får aldrig stoppa köpet. */
  function ph(name, payload) { try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, payload); } catch (e) {} }
  function kr(cents) { return Math.round(Number(cents) || 0) / 100; }
  function meterTotal() { var m = $('.svd-cart--core [data-svd-meter]') || $('[data-svd-meter]'); return Number(m && m.dataset.total) || 0; }
  function unlockPayload(el, action) {
    var d = el.dataset;
    return { block: 'unlock', action: action, via: d.via || 'cart', goal: d.goal || null, goal_kr: kr(d.goalCents), need_kr: kr(d.need), handle: d.handle || null, price_kr: kr(d.price) };
  }
  function trackUnlockViews(via) {
    $$('[data-svd-unlock][data-via="' + via + '"]').forEach(function (el) {
      var key = 'u:' + via + ':' + el.dataset.goal + ':' + el.dataset.handle;
      if (seen[key]) return; seen[key] = 1;
      ph('svd_cart_block', unlockPayload(el, 'view'));
    });
  }
  function unlockSnapshot(el) { return { payload: unlockPayload(el, 'add'), goalCents: Number(el.dataset.goalCents) || Infinity }; }
  function trackUnlockAdd(snap, before, after) {
    var p = snap.payload;
    p.total_before_kr = kr(before); p.total_after_kr = kr(after); p.reached = after >= snap.goalCents;
    ph('svd_cart_block', p);
  }

  /* ---------- Alla block (24/9, Eriks "se ALLT om korgen på en dashboard") ----------
     Samma event som upplåsningen: svd_cart_block { block, action, cart_total_kr, ... }.
     Vyer räknas EN gång per sidladdning och block (paketkortet per paket-titel), bara när
     blocket faktiskt har innehåll. Klick/val/öppningar räknas varje gång. Block-namnen är
     svenska och stabila – dashboarden i PostHog filtrerar på dem. */
  function blk(block, action, props) {
    var p = { block: block, action: action, cart_total_kr: kr(meterTotal()) };
    if (props) for (var k in props) if (props[k] !== undefined && props[k] !== null && props[k] !== '') p[k] = props[k];
    ph('svd_cart_block', p);
  }
  function txt(el) { return el ? el.textContent.trim().slice(0, 80) : null; }
  function blockOf(el) {
    if (!el || !el.closest) return null;
    if (el.closest('[data-svd-unlock]')) return 'unlock';
    if (el.closest('[data-svd-spotlight]') || el.closest('.svd-cart--deals')) return 'deals';
    if (el.closest('.svd-cart--fav')) return 'favoriter';
    if (el.closest('.svd-cart--paket')) return 'paket';
    if (el.closest('[data-svd-giftgrp]')) return 'gavor';
    if (el.closest('.svd-cart__row')) return 'rad';
    if (el.closest('[data-svd-pop]')) return 'popup';
    return 'okand';
  }
  var BLOCK_VIEWS = [
    ['paket', '.svd-cart--paket', '[data-svd-upgrade]', function (r) { var t = txt($('[data-svd-pk-h]', r)); return { key: t, props: { title: t, slides: $$('.svd-cart__pk-slide', r).length } }; }],
    ['favoriter', '.svd-cart--fav', '.svd-cart__card', function (r) { return { props: { cards: $$('.svd-cart__card', r).length, tabs: $$('[data-svd-tab]', r).length } }; }],
    ['deals', '.svd-cart--deals', '[data-svd-spotlight]', function (r) { return { props: { cards: $$('[data-svd-spotlight]', r).length } }; }],
    ['gavor', '[data-svd-giftgrp]', null, function (r) { return { props: { gifts: $$('[data-svd-gkey]', r).length } }; }],
    ['recensioner', '.svd-cart--revs', null, null],
    ['trust', '.svd-cart--trust', null, null],
    ['varfor', '.svd-cart--why', null, null]
  ];
  function trackBlockViews() {
    BLOCK_VIEWS.forEach(function (d) {
      var r = $(d[1]); if (!r) return;
      if (d[2] && !$(d[2], r)) return;
      var info = d[3] ? d[3](r) : {}, key = 'b:' + d[0] + ':' + (info.key || '');
      if (seen[key]) return; seen[key] = 1;
      blk(d[0], 'view', info.props);
    });
  }

  /* ---------- Superdeals-popupen vid "Gå till kassan" ---------- */
  var passthrough = false, popTimer = null, popBusy = false;
  function popEl() { return $('[data-svd-pop]'); }
  function openPop(pop) {
    pop.hidden = false; pop.setAttribute('data-svd-open', '');
    document.documentElement.style.overflow = 'hidden';
    var t = parseInt(pop.dataset.seconds, 10) || 180, el = $('[data-svd-pop-timer]', pop);
    var render = function () { if (el) el.textContent = String(Math.floor(t / 60)).padStart(2, '0') + ':' + String(t % 60).padStart(2, '0'); if (t <= 0) { clearInterval(popTimer); return; } t--; };
    clearInterval(popTimer); render(); popTimer = setInterval(render, 1000);
    projectMeter(pop);
    blk('popup', 'open', { deals: $$('[data-svd-pop-item]:not([data-svd-unlock])', pop).length, unlock: !!$('[data-svd-unlock]', pop) });
  }
  function closePop() {
    var pop = popEl(); if (!pop) return;
    pop.hidden = true; pop.removeAttribute('data-svd-open'); clearInterval(popTimer);
    document.documentElement.style.overflow = '';
  }
  /* Mätaren i popupen följer valen live: korgens total + valda deals. */
  function projectMeter(pop) {
    var m = $('[data-svd-meter]', pop); if (!m) return;
    var total = Number(m.dataset.total) || 0, fs = Number(m.dataset.fs) || 0, goal = Number(m.dataset.goal) || fs;
    $$('[data-svd-pop-item].is-on', pop).forEach(function (r) { total += Number(r.dataset.priceCents) || 0; });
    var kr = function (c) { return Math.ceil(c / 100).toLocaleString('sv-SE') + ' kr'; };
    var two = goal > fs, txt;
    if (total < fs) txt = (m.dataset.tFs || '').replace('[amount]', kr(fs - total));
    else if (two && total < goal) txt = (m.dataset.tGift || '').replace('[amount]', kr(goal - total));
    else txt = two ? m.dataset.tAll : m.dataset.tFsonly;
    $('[data-svd-meter-t]', m).innerHTML = txt || '';
    var bar = $('[data-svd-meter-bar]', m); if (bar) bar.style.width = Math.min(100, total * 100 / goal) + '%';
    var fsM = $('[data-svd-meter-fs]', m); if (fsM) fsM.classList.toggle('is-done', total >= fs);
    var end = $('[data-svd-meter-end]', m); if (end) end.classList.toggle('is-done', total >= (two ? goal : fs));
  }
  function goCheckout(includeDeals) {
    var pop = popEl();
    var items = [];
    if (includeDeals && pop) $$('[data-svd-pop-item].is-on', pop).forEach(function (r) { var pr = json(r.dataset.props, {}); pr._svd_via = 'popup'; items.push({ id: Number(r.dataset.variantId), quantity: 1, properties: pr }); });
    /* Tar valen korgen över gåvogränsen följer gåvan med i SAMMA anrop – popupen lovar
       "fri frakt + gratis gåva" och kunden ska inte gå till kassan utan den. Efteråt kontrolleras
       att regeln gjorde den gratis; annars tas den bort igen innan kassan (aldrig en betald "gåva"). */
    var core = root(), giftVid = 0;
    /* Gåvan bara via upplåsningsblocket (data-svd-gift-unlock finns): då krävs att korgen redan har
       blockets _unlock=gift-rad ("1") – samma villkor som kärnan (gift_via_unlock). */
    var unlockOk = !core || core.dataset.svdGiftUnlock == null || core.dataset.svdGiftUnlock === '1';
    if (items.length && unlockOk && core && core.dataset.svdGiftVid && core.dataset.svdGiftHave !== '1') {
      var mm = $('[data-svd-meter]'), projected = Number(mm && mm.dataset.total) || 0;
      items.forEach(function (it) { var r = $('[data-svd-pop-item][data-variant-id="' + it.id + '"]', pop); projected += Number(r && r.dataset.priceCents) || 0; });
      if (projected >= (Number(core.dataset.svdGiftGoal) || Infinity)) { giftVid = Number(core.dataset.svdGiftVid); items.push({ id: giftVid, quantity: 1, properties: GIFT_PROPS }); }
    }
    var proceed = function () {
      passthrough = true;
      var form = document.getElementById('svd-cart-form'), btn = $('[data-svd-checkout]');
      if (form && btn && form.requestSubmit) form.requestSubmit(btn); else window.location.href = '/checkout';
    };
    if (!items.length) { proceed(); return; }
    if (popBusy) return;
    popBusy = true;
    var lbl = $('[data-svd-pop-lbl]', pop), err = $('[data-svd-pop-err]', pop), old = lbl && lbl.textContent;
    if (lbl) { lbl.dataset.label = old; lbl.textContent = lbl.dataset.busy || 'Lägger till…'; }
    if (err) err.hidden = true;
    enqueue(function () {
      return rawPost('/cart/add.js', { items: items }).then(function () {
        if (!giftVid) return null;
        return cartJs().then(function (cart) {
          var g = null; cart.items.some(function (it) { if (it.variant_id === giftVid && (it.properties || {})._gwp_gift) { g = it; return true; } return false; });
          return g && g.final_line_price > 0 ? rawPost('/cart/change.js', { id: g.key, quantity: 0 }) : null;
        });
      });
    })
      .then(proceed)
      .catch(function (e) { console.error('[SvdCart] popup', e); popBusy = false; if (lbl) lbl.textContent = old; if (err) err.hidden = false; });
  }

  /* ---------- Klick ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var b;

    if ((b = t.closest('[data-svd-checkout]')) && !passthrough) {
      var pop = popEl();
      blk('kassa', 'click', { popup: !!(pop && $('[data-svd-pop-item]', pop)) });
      if (pop && $('[data-svd-pop-item]', pop)) { e.preventDefault(); openPop(pop); }
      return;
    }
    if ((b = t.closest('[data-svd-pop-toggle]'))) {
      var row = b.closest('[data-svd-pop-item]'), on = !row.classList.contains('is-on');
      row.classList.toggle('is-on', on); b.classList.toggle('is-added', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = on ? b.dataset.labelOn : b.dataset.label;
      projectMeter(popEl());
      blk('popup', on ? 'select' : 'deselect', { kind: row.hasAttribute('data-svd-unlock') ? 'unlock' : 'deal', variant_id: Number(row.dataset.variantId) || null, price_kr: kr(row.dataset.priceCents), handle: row.dataset.handle || null });
      return;
    }
    if (t.closest('[data-svd-pop-go]')) { blk('popup', 'go', { selected: $$('[data-svd-pop-item].is-on', popEl()).length }); goCheckout(true); return; }
    if (t.closest('[data-svd-pop-skip]')) { blk('popup', 'skip', { selected: $$('[data-svd-pop-item].is-on', popEl()).length }); goCheckout(false); return; }
    if (t.closest('[data-svd-pop-close]')) { blk('popup', 'close', { selected: $$('[data-svd-pop-item].is-on', popEl()).length }); closePop(); return; }

    if ((b = t.closest('[data-svd-qty]'))) {
      e.preventDefault();
      var r = b.closest('[data-key]'), inp = r && $('[data-svd-qty-input]', r);
      if (!inp) return;
      var v = parseInt(inp.value, 10) || 1;
      blk('rad', b.dataset.svdQty === 'plus' ? 'plus' : 'minus', { handle: r.dataset.svdHandle || null });
      setQty(r, b.dataset.svdQty === 'plus' ? v + 1 : Math.max(0, v - 1));
      return;
    }
    if ((b = t.closest('[data-svd-remove]'))) { e.preventDefault(); var rr = b.closest('[data-key]'); if (rr) { blk('rad', 'remove', { handle: rr.dataset.svdHandle || null }); removeRow(rr); } return; }

    if ((b = t.closest('[data-svd-qv-add]'))) {
      var d = qvData; if (!d) return;
      if (d.u) { b.disabled = true; flash(b, true); upgrade(d.u, null, d); setTimeout(closeQv, 350); return; }
      b.dataset.props = JSON.stringify(d.pr || {});
      b.dataset.variantId = d.v;
      addFromButton(b, d);
      setTimeout(closeQv, 350);
      return;
    }
    if ((b = t.closest('[data-svd-add]'))) { e.preventDefault(); if (!b.disabled) addFromButton(b); return; }
    if ((b = t.closest('[data-svd-upgrade]'))) { e.preventDefault(); if (!b.disabled) upgrade(json(b.dataset.svdUpgrade, {}), b); return; }

    if ((b = t.closest('[data-svd-qv-open]'))) { e.preventDefault(); openQv(b.closest('[data-svd-qv]')); return; }
    if (t.closest('[data-svd-qv-close]')) { closeQv(); return; }

    if ((b = t.closest('[data-svd-tab]'))) { blk('favoriter', 'tab', { tab: txt(b) }); selectTab(b); return; }
    if (t.closest('[data-svd-giftgrp-toggle]')) { ui.giftsOpen = !ui.giftsOpen; blk('gavor', ui.giftsOpen ? 'open' : 'close'); applyUi(); return; }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-svd-qty-input]');
    if (!inp) return;
    var r = inp.closest('[data-key]'); if (r) setQty(r, Math.max(0, parseInt(inp.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeQv(); closePop(); } });
  /* Fallback: formulärets submit via tangentbord öppnar också popupen. */
  document.addEventListener('submit', function (e) {
    if (passthrough || !e.target || e.target.id !== 'svd-cart-form') return;
    var pop = popEl();
    if (pop && $('[data-svd-pop-item]', pop)) { e.preventDefault(); openPop(pop); }
  }, true);

  /* ---------- Gåvornas skyddsnät (oförändrad logik sedan 2026-08) ---------- */
  /* GSO-gåvor (_gwp + _gwp_main): försvinner huvudprodukten eller faller antalet under
     _gwp_min tas gåvan bort (annars debiteras kunden). Max ett försök per rad och sidvisning. */
  var gwpBusy = false, gwpTried = {};
  function syncGwp() {
    if (gwpBusy) return;
    var gifts = $$('[data-svd-gwpmain]'); if (!gifts.length) return;
    var counts = {};
    $$('[data-svd-pid]').forEach(function (r) { if (r.hasAttribute('data-svd-gwp')) return; counts[r.dataset.svdPid] = (counts[r.dataset.svdPid] || 0) + (parseInt(r.dataset.svdPqty, 10) || 0); });
    /* Antalsspärr (2026-11-03, dubbla gåvor #24558/#24560): köps paketet två gånger slås
       gåvoraderna ihop till 2 st, och minus på huvudraden sänkte aldrig gåvorna. Stackens
       gåvor ska finnas EN gång per huvudprodukt (oavsett antal flaskor) → en GSO-gåva med
       fler än stacken listar sätts ner. Gäller bara gåvor som huvudradens stack listar
       (data-svd-gsoexp) – svd.gwp_rule-gåvor med avsiktligt gift_quantity rörs inte. */
    var gsoMax = {};
    $$('[data-svd-gsoexp]').forEach(function (m) {
      if (m.hasAttribute('data-svd-gwp')) return;
      var per = {};
      (m.dataset.svdGsoexp || '').split(',').forEach(function (v) { v = v.trim(); if (v) per[v] = (per[v] || 0) + 1; });
      Object.keys(per).forEach(function (v) { var k = m.dataset.svdPid + ':' + v; gsoMax[k] = Math.max(gsoMax[k] || 0, per[v]); });
    });
    var updates = {}, n = 0;
    gifts.forEach(function (g) {
      var key = g.dataset.key;
      if (!key || gwpTried[key]) return;
      if ((counts[g.dataset.svdGwpmain] || 0) < (parseInt(g.dataset.svdGwpmin, 10) || 1)) { updates[key] = 0; gwpTried[key] = true; n++; fadeGift(key, true); return; }
      var max = gsoMax[g.dataset.svdGwpmain + ':' + g.dataset.svdVid];
      if (max && (parseInt(g.dataset.svdPqty, 10) || 0) > max) { updates[key] = max; gwpTried[key] = true; n++; }
    });
    if (!n) return;
    gwpBusy = true;
    update(updates).catch(function (e) { console.error('[SvdCart] gåvostädningen', e); }).then(function () {
      Object.keys(updates).forEach(function (k) { if (!$('[data-key="' + k + '"]')) delete gwpTried[k]; });
      gwpBusy = false; syncGwp();
    });
  }
  /* Stack-gåvor som SAKNAS läggs till (GSO-skyddsnätet 2026-08-25). Sanningen = /cart.js. */
  var gwpAdding = false, gwpAddTried = {};
  /* Snabbkoll i DOM:en: ligger varje väntad gåva redan som gåvorad (0 kr) behövs ingen
     /cart.js-läsning (granskningen 23/9: ett extra anrop per klick). Saknas något avgör
     /cart.js som förut – tillägg görs ALDRIG på DOM:ens ord (dubblett-fällan 2026-08-25). */
  function gwpAllPresent(mains) {
    var have = {};
    $$('.svd-cart__side [data-svd-gkey][data-svd-vid]').forEach(function (g) { have[g.dataset.svdVid] = true; });
    return mains.every(function (m) {
      return (m.dataset.svdGsoexp || '').split(',').every(function (v) { v = v.trim(); return !v || have[v]; });
    });
  }
  function syncGwpAdd() {
    if (gwpAdding || gwpBusy) return;
    var mains = $$('[data-svd-gsoexp]').filter(function (m) { return !m.hasAttribute('data-svd-gwp'); }); if (!mains.length) return;
    if (gwpAllPresent(mains)) return;
    gwpAdding = true;
    cartJs().then(function (cart) {
      var have = {}, qty = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (p._gwp || p._gift || p._prengava) { have[String(it.variant_id)] = true; return; }
        qty[String(it.product_id)] = (qty[String(it.product_id)] || 0) + it.quantity;
      });
      var items = [];
      mains.forEach(function (m) {
        if (m.hasAttribute('data-svd-gwp')) return;
        var pid = m.dataset.svdPid || '', need = parseInt(m.dataset.svdGsomin, 10) || 1;
        if ((qty[pid] || 0) < need) return;
        (m.dataset.svdGsoexp || '').split(',').forEach(function (vid) {
          vid = vid.trim(); if (!vid || have[vid]) return;
          var k = pid + ':' + vid; if (gwpAddTried[k]) return;
          gwpAddTried[k] = true; have[vid] = true;
          items.push({ id: parseInt(vid, 10), properties: { _gwp: 'true', _gwp_main: pid, _gwp_min: String(need) } });
        });
      });
      if (!items.length) { dropPending(); return null; }
      return add(items);
    }).then(function () { gwpAdding = false; }, function () { gwpAdding = false; dropPending(); });
  }
  /* Kärnan reserverar plats för gåvor som ska läggas till ([data-svd-gpending]). Blir det inget
     tillägg (misslyckat eller redan försökt) hämtas korgen om EN gång så att de inte står kvar. */
  var pendingDropped = false;
  function dropPending() { if (!pendingDropped && $('[data-svd-gpending]')) { pendingDropped = true; refresh(); } }
  function syncAll() { syncGwp(); syncGwpAdd(); syncGift(); }
  document.addEventListener('svd-cart:updated', syncAll);

  function init() {
    if (!root()) return;
    applyUi();
    syncAll();
    /* Gör bilderna i snabbvyn redo: första trycket på en knapp förladdar skarp bild. */
    document.addEventListener('pointerdown', function (e) {
      var h = e.target.closest && e.target.closest('[data-svd-qv-open]');
      var d = h && json((h.closest('[data-svd-qv]') || {}).dataset && h.closest('[data-svd-qv]').dataset.svdQv, null);
      if (d && d.i) { var i = new Image(); i.src = d.i; }
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Bakåtknappen från kassan: sidan kan komma tillbaka ur webbläsarens bfcache precis som den
     lämnades – popupen öppen med "Lägger till…", scrollen låst och korgen utan det som lades
     till. Återställ och hämta färskt läge (granskningen 23/9). */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !root()) return;
    passthrough = false; popBusy = false;
    var lbl = $('[data-svd-pop-lbl]');
    if (lbl && lbl.dataset.label) lbl.textContent = lbl.dataset.label;
    closePop(); closeQv();
    refresh();
  });

  window.SvdCart = { add: add, refresh: refresh, enqueue: enqueue };
})();
